import {Formik, Form} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {addNFCtoBus, getNFC} from './api'
import {useQuery} from 'react-query'
import {RunnerBall} from '../../../components/FormLoader'
import {handleApiError} from '../../../helpers/errorHandler'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'

function NFC({initialValues: busDetails, onAfterSubmit}) {
  const {data, isFetching} = useQuery('nfc', () => getNFC(busDetails.bus_id), {
    refetchOnWindowFocus: false,
  })
  if (isFetching) {
    return <RunnerBall />
  }

  const attendance = data?.data?.find((device) => device.type === 'attendance')
  const trip = data?.data?.find((device) => device.type === 'trip')

  const submitHandler = (values, {setSubmitting: setLoading}) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')

    addNFCtoBus({
      bus_id: values.bus_id,
      nfc_attendance: values.nfc_attendance,
      nfc_trip: values.nfc_trip,
    })
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err) => {
        console.error(err)
        handleApiError(err, toastId)
      })
      .finally((res) => setLoading(false))
  }
  const formValues = {
    nfc_attendance: attendance?.device_id || '',
    nfc_trip: trip?.device_id || '',
    bus_name: busDetails.bus_name + ' - ' + busDetails.bus_registration_number,
    bus_id: busDetails.bus_id,
  }
  return (
    <div className="px-5 py-3">
      <Formik
        initialValues={formValues}
        validationSchema={Yup.object({
          nfc_attendance: Yup.string()
            .trim()
            .required('Attendance RFID is required')
            .notOneOf([''], 'Attendance RFID is required'),
          nfc_trip: Yup.string()
            .trim()
            .required('Trip RFID is required')
            .notOneOf([''], 'Trip RFID is required'),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <FormikControl
              control="input"
              placeholder="Bus"
              label="Bus Brand"
              name="bus_name"
              disabled
            />
            <FormikControl
              control="input"
              required
              placeholder="Attendance RFID"
              label="Attendance RFID"
              name="nfc_attendance"
            />
            <FormikControl
              control="input"
              required
              placeholder="Trip RFID"
              label="Trip RFID"
              name="nfc_trip"
            />

            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default NFC
